export default "__VITE_ASSET__WDTm7Yuy__"